import React, { useRef, useEffect } from 'react';

interface IProps {
  values: { notes?: string };
  setValues: (
    value:
      | { notes?: string }
      | ((prev: { notes?: string }) => { notes?: string }),
  ) => void;
}

export default function EditNotes({ values, setValues }: IProps) {
  const notes = values.notes ?? '';
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const el = textareaRef.current;
    if (el && el.value !== notes) {
      el.value = notes;
    }
  }, [notes]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (
      (e.ctrlKey || e.metaKey) &&
      (e.key === 'z' || e.key === 'y' || e.key === 'Z' || e.key === 'Y')
    ) {
      e.stopPropagation();
    }
  };

  return (
    <div className="mt-4 flex flex-col gap-2">
      <textarea
        ref={textareaRef}
        id="device-notes"
        name="notes"
        rows={8}
        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-400 focus:outline-none focus:ring-1 focus:ring-blue-400"
        placeholder="Add notes for documentation export…"
        defaultValue={notes}
        data-testid="node-edit-notes-textarea"
        onChange={(e) => setValues({ notes: e.target.value })}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
}
